export default __webpack_public_path__ + "static/media/ipad-bear.2efb6657.svg";